import React, { useEffect } from "react";
import { Box, Button, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";


const penetracoesCBR = [
  { mm: "0,63", tempo: "0,5" },
  { mm: "1,27", tempo: "1,0" },
  { mm: "1,90", tempo: "1,5" },
  { mm: "2,54", tempo: "2,0" },
  { mm: "3,81", tempo: "3,0" },
  { mm: "5,08", tempo: "4,0" },
  { mm: "6,35", tempo: "5,0" },
  { mm: "7,62", tempo: "6,0" },
  { mm: "8,89", tempo: "7,0" },
  { mm: "10,16", tempo: "8,0" },
  { mm: "12,70", tempo: "10,0" },
];

const peneiras = [
  ['4"', "101,8"], ['3 1/2"', "88,9"], ['3"', "76,2"], ['2 1/2"', "63,5"],
  ['2"', "50,8"], ['1 1/2"', "38,1"], ['1"', "25,4"], ['3/4"', "19"],
  ['1/2"', "12,7"], ['3/8"', "9,5"], ["4", "4,8"], ["8", "2,4"],
  ["10", "2"], ["16", "1,2"], ["30", "0,6"], ["40", "0,42"],
  ["50", "0,3"], ["60", "0,25"], ["100", "0,15"], ["200", "0,075"], ["FUNDO", ""],
];

function n(valor) {
  if (valor === null || valor === undefined || valor === "") return null;

  let texto = String(valor).trim().replace(/\s/g, "");

  if (!texto) return null;

  if (texto.includes(",") && texto.includes(".")) {
    texto = texto.replace(/\./g, "").replace(",", ".");
  } else if (texto.includes(",")) {
    texto = texto.replace(",", ".");
  }

  const v = Number(texto);
  return Number.isFinite(v) ? v : null;
}

function fmt(valor, casas = 1) {
  const v = typeof valor === "number" ? valor : n(valor);
  if (v === null) return "-";
  return v.toLocaleString("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas });
}

function dataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : dataISO;
}

function val(v) {
  return v === null || v === undefined || v === "" ? "-" : v;
}

function leituraRegistrada(v) {
  return String(v ?? "").trim() !== "";
}

function compactos(ensaio) {
  return (ensaio.compactacao || []).slice(0, 5);
}

function umidadesHigroscopicas(ensaio) {
  const linhas = ensaio.granulometria?.umidadeHigroscopica || [];
  return [linhas[0] || {}, linhas[1] || {}];
}

function Page({ children, className = "" }) {
  return (
    <div className={`rc-page ${className}`.trim()}>
      <div className="rc-page-inner">{children}</div>
    </div>
  );
}

function Header({ ensaio, codigo, titulo, revisao = "Revisão 01" }) {
  return (
    <>
      <table className="rc-table rc-head">
        <tbody>
          <tr>
            <td rowSpan="3" className="rc-logo">
              <LogoRelatorio alt="Logo da empresa" className="rc-logo-img"  />
            </td>
            <td rowSpan="3" className="rc-title">
              <div>SISTEMA DE GESTÃO DA QUALIDADE</div>
              <div>{titulo}</div>
            </td>
            <td className="rc-code">{codigo}</td>
          </tr>
          <tr><td className="rc-code">{revisao}</td></tr>
          <tr><td className="rc-code">{dataBR(ensaio.dataEnsaio)}</td></tr>
        </tbody>
      </table>
      <table className="rc-table rc-meta">
        <tbody>
          <tr>
            <td colSpan="2">EMPRESA:<br />{val(ensaio.empresa || ensaio.cliente)}</td>
            <td colSpan="2">OBRA:<br />{val(ensaio.obra)}</td>
          </tr>
          <tr>
            <td>CAMADA/ESTUDO:<br /><b>{val(ensaio.camadaEstudo)}</b></td>
            <td>MATERIAL:<br /><b>{val(ensaio.material)}</b></td>
            <td>LOCAL DE COLETA:<br /><b>{val(ensaio.localColeta)}</b></td>
            <td>REGISTRO Nº:<br /><b>{val(ensaio.registroNumero || ensaio.codigo)}</b></td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

function Footer({ ensaio }) {
  return (
    <table className="rc-table rc-footer">
      <tbody>
        <tr>
          <td>LABORATÓRIO:<div className="rc-sign"></div></td>
          <td>FISCALIZAÇÃO:</td>
          <td>DATA:<br /><br />{dataBR(ensaio.dataEnsaio)}</td>
        </tr>
      </tbody>
    </table>
  );
}

function Summary({ ensaio }) {
  return (
    <table className="rc-table rc-summary">
      <tbody>
        <tr><th colSpan="6">RESUMO</th></tr>
        <tr>
          <td><b>DENS. MÁX.</b> {val(ensaio.resultados?.densidadeMaxima)} g/cm³</td>
          <td><b>UMID. HOT.</b> {val(ensaio.resultados?.umidadeOtima)} %</td>
          <td><b>I.S.C.</b> {val(ensaio.resultados?.isc)} %</td>
          <td><b>EXP.</b> {val(ensaio.resultados?.expansao)} %</td>
          <td><b>I.G.</b> {val(ensaio.resultados?.ig || ensaio.granulometria?.classificacaoIg)}</td>
          <td><b>T.R.B.</b> {val(ensaio.resultados?.trb || ensaio.granulometria?.classificacaoTrb)}</td>
        </tr>
      </tbody>
    </table>
  );
}

function PolyChart({
  series,
  width = 680,
  height = 300,
  yLabel = "",
  xLabel = "",
  colors = ["#000"],
  guides = [],
  correctionOffset = null,
  tangent = null,
}) {
 const all = series
  .flatMap((s) => s.points)
  .filter((p) => p.x !== null && p.y !== null);

const vazio = !all.length;

const dadosBase = vazio
  ? [{ x: 0, y: 0 }, { x: 10, y: 10 }]
  : all;

  
  const minX = Math.min(...dadosBase.map((p) => p.x));
const maxX = Math.max(...dadosBase.map((p) => p.x));
const minY = Math.min(...dadosBase.map((p) => p.y));
const maxY = Math.max(...dadosBase.map((p) => p.y));
  const pad = 42;
  const sx = (x) => pad + ((x - minX) / (maxX - minX || 1)) * (width - pad * 1.5);
  const sy = (y) => height - pad - ((y - minY) / (maxY - minY || 1)) * (height - pad * 1.6);
  const gerarCurvaTendencia = (pontos = [], amostras = 80) => {
  const dados = pontos
    .filter((p) => p.x !== null && p.y !== null)
    .sort((a, b) => a.x - b.x);

  if (dados.length < 3) return dados;

  const grau = Math.min(4, dados.length - 1);

  const matriz = [];
  const vetor = [];

  for (let linha = 0; linha <= grau; linha += 1) {
    matriz[linha] = [];

    for (let coluna = 0; coluna <= grau; coluna += 1) {
      matriz[linha][coluna] = dados.reduce(
        (soma, p) => soma + Math.pow(p.x, linha + coluna),
        0
      );
    }

    vetor[linha] = dados.reduce(
      (soma, p) => soma + p.y * Math.pow(p.x, linha),
      0
    );
  }

  for (let i = 0; i <= grau; i += 1) {
    let max = i;

    for (let k = i + 1; k <= grau; k += 1) {
      if (Math.abs(matriz[k][i]) > Math.abs(matriz[max][i])) max = k;
    }

    [matriz[i], matriz[max]] = [matriz[max], matriz[i]];
    [vetor[i], vetor[max]] = [vetor[max], vetor[i]];

    const divisor = matriz[i][i] || 1;

    for (let j = i; j <= grau; j += 1) matriz[i][j] /= divisor;
    vetor[i] /= divisor;

    for (let k = 0; k <= grau; k += 1) {
      if (k === i) continue;

      const fator = matriz[k][i];

      for (let j = i; j <= grau; j += 1) {
        matriz[k][j] -= fator * matriz[i][j];
      }

      vetor[k] -= fator * vetor[i];
    }
  }

  const min = dados[0].x;
  const max = dados[dados.length - 1].x;
  const curva = [];

  for (let i = 0; i <= amostras; i += 1) {
    const x = min + ((max - min) * i) / amostras;

    const y = vetor.reduce(
      (soma, coef, idx) => soma + coef * Math.pow(x, idx),
      0
    );

    curva.push({ x, y });
  }

  return curva;
};
  return (
    <svg className="rc-chart" viewBox={`0 0 ${width} ${height}`}>
      {Array.from({ length: 11 }, (_, i) => <line key={`v${i}`} x1={pad + i * ((width - pad * 1.5) / 10)} y1={20} x2={pad + i * ((width - pad * 1.5) / 10)} y2={height - pad} stroke="#999" strokeWidth="0.5" />)}
      {Array.from({ length: 10 }, (_, i) => <line key={`h${i}`} x1={pad} y1={20 + i * ((height - pad - 20) / 9)} x2={width - pad / 2} y2={20 + i * ((height - pad - 20) / 9)} stroke="#999" strokeWidth="0.5" />)}
      <line x1={pad} y1={20} x2={pad} y2={height - pad} stroke="#000" />
      <line x1={pad} y1={height - pad} x2={width - pad / 2} y2={height - pad} stroke="#000" />
      {correctionOffset !== null && correctionOffset > 0 && (
        <>
          <line
            x1={sx(correctionOffset)}
            y1={sy(0)}
            x2={sx(correctionOffset)}
            y2={sy(maxY * 0.12)}
            stroke="#9a6700"
            strokeDasharray="3 2"
          />
          <text x={sx(correctionOffset)} y={sy(0) - 4} textAnchor="middle" fontSize="8" fill="#9a6700">c</text>
        </>
      )}
      {tangent && (
        <>
          <line
            x1={sx(tangent.x1)}
            y1={sy(tangent.y1)}
            x2={sx(tangent.x2)}
            y2={sy(tangent.y2)}
            stroke="#9a6700"
            strokeWidth="1"
          />
          <circle cx={sx(tangent.x2)} cy={sy(tangent.y2)} r="2.5" fill="#9a6700" />
          <text x={sx(tangent.x2)} y={sy(tangent.y2) - 4} textAnchor="middle" fontSize="7" fill="#9a6700">I</text>
        </>
      )}
      {guides.map((guide) => (
        <g key={guide.label}>
          <line x1={sx(guide.x)} y1={sy(0)} x2={sx(guide.x)} y2={sy(guide.y)} stroke={guide.color} strokeDasharray="3 2" strokeWidth="0.8" />
          <line x1={sx(0)} y1={sy(guide.y)} x2={sx(guide.x)} y2={sy(guide.y)} stroke={guide.color} strokeDasharray="3 2" strokeWidth="0.8" />
          <text x={sx(guide.x) - 2} y={sy(guide.y) - 3} textAnchor="end" fontSize="7" fill={guide.color}>{guide.label}</text>
        </g>
      ))}
      {!vazio && series.map((s, i) => {
        const points = s.points.filter((p) => p.x !== null && p.y !== null);
       
const curva = s.linear
  ? points
  : s.interpolate
  ? gerarSplineNatural(points, 20)
  : gerarCurvaTendencia(points, 100);

const d = curva
  .map((p, idx) => `${idx === 0 ? "M" : "L"} ${sx(p.x)} ${sy(p.y)}`)
  .join(" ");

        return <path key={s.name || i} d={d} fill="none" stroke={colors[i] || "#000"} strokeWidth="1" strokeDasharray={s.strokeDasharray} />;
      })}
       {!vazio && series.flatMap((s, si) =>
         s.showPoints === false
           ? []
           : s.points
               .filter((p) => p.x !== null && p.y !== null)
               .map((p, pi) => (
                 <circle key={`${si}-${pi}`} cx={sx(p.x)} cy={sy(p.y)} r="2.5" fill={colors[si] || "#000"} />
               ))
       )}
      <text x={width / 2} y={height - 6} textAnchor="middle" fontSize="11" fill="blue">{xLabel}</text>
      <text x="12" y={height / 2} textAnchor="middle" fontSize="11" fill="blue" transform={`rotate(-90 12 ${height / 2})`}>{yLabel}</text>
    </svg>
  );
}

function LimiteLiquidezChart({ liquidez = [], escala = {}, width = 620, height = 310 }) {
  const pontos = liquidez
    .map((linha) => ({
      golpes: n(linha.numeroGolpes || linha.golpes),
      umidade: n(linha.umidade),
    }))
    .filter((ponto) => ponto.golpes !== null && ponto.golpes > 0 && ponto.umidade !== null)
    .sort((a, b) => a.golpes - b.golpes);

  const margem = { left: 70, right: 55, top: 52, bottom: 48 };
  const plotW = width - margem.left - margem.right;
  const plotH = height - margem.top - margem.bottom;
  const golpesMinInformado = n(escala.golpesMin);
  const golpesMaxInformado = n(escala.golpesMax);
  const umidadeMinInformada = n(escala.umidadeMin);
  const umidadeMaxInformada = n(escala.umidadeMax);
  const escalaGolpesValida =
    golpesMinInformado !== null && golpesMinInformado > 0 &&
    golpesMaxInformado !== null && golpesMaxInformado > golpesMinInformado;
  const escalaUmidadeValida =
    umidadeMinInformada !== null && umidadeMaxInformada !== null &&
    umidadeMaxInformada > umidadeMinInformada;
  const minGolpes = escalaGolpesValida ? golpesMinInformado : 10;
  const maxGolpes = escalaGolpesValida ? golpesMaxInformado : 50;
  const minY = escalaUmidadeValida ? umidadeMinInformada : 25;
  const maxY = escalaUmidadeValida ? umidadeMaxInformada : 50;
  const criarTicks = (minimo, maximo) =>
    Array.from({ length: 6 }, (_, index) =>
      Number((minimo + ((maximo - minimo) * index) / 5).toFixed(2))
    );
  const ticksGolpes =
    minGolpes === 10 && maxGolpes === 50
      ? [10, 20, 25, 30, 40, 50]
      : criarTicks(minGolpes, maxGolpes);
  const ticksUmidade = criarTicks(minY, maxY);
  const sx = (golpes) =>
    margem.left +
    ((Math.log10(golpes) - Math.log10(minGolpes)) /
      (Math.log10(maxGolpes) - Math.log10(minGolpes))) *
      plotW;
  const sy = (umidade) => margem.top + ((maxY - umidade) / (maxY - minY)) * plotH;

  let reta = null;

  if (pontos.length >= 2) {
    const total = pontos.length;
    const somaX = pontos.reduce((acc, p) => acc + Math.log10(p.golpes), 0);
    const somaY = pontos.reduce((acc, p) => acc + p.umidade, 0);
    const somaXY = pontos.reduce((acc, p) => acc + Math.log10(p.golpes) * p.umidade, 0);
    const somaX2 = pontos.reduce((acc, p) => acc + Math.log10(p.golpes) ** 2, 0);
    const denominador = total * somaX2 - somaX ** 2;

    if (denominador !== 0) {
      const a = (total * somaXY - somaX * somaY) / denominador;
      const b = (somaY - a * somaX) / total;
      const ll25 = a * Math.log10(25) + b;
      reta = {
        x1: sx(minGolpes),
        y1: sy(a * Math.log10(minGolpes) + b),
        x2: sx(maxGolpes),
        y2: sy(a * Math.log10(maxGolpes) + b),
        x25: sx(25),
        y25: sy(ll25),
      };
    }
  }

  return (
    <svg className="rc-chart rc-limite-liquidez-chart" viewBox={`0 0 ${width} ${height}`}>
      <defs>
        <clipPath id="clip-limite-liquidez-relatorio">
          <rect x={margem.left} y={margem.top} width={plotW} height={plotH} />
        </clipPath>
      </defs>
      <rect x="1" y="1" width={width - 2} height={height - 2} fill="#fff" stroke="#000" />
      <text x={width / 2} y="27" textAnchor="middle" fontSize="13" fontWeight="700" fill="#7b8794">
        LIMITE DE LIQUIDEZ
      </text>
      {ticksUmidade.map((umidade) => (
        <g key={umidade}>
          <line x1={margem.left} x2={width - margem.right} y1={sy(umidade)} y2={sy(umidade)} stroke="#263238" strokeWidth="0.6" />
          <text x={margem.left - 12} y={sy(umidade) + 4} textAnchor="end" fontSize="10">{umidade}</text>
        </g>
      ))}
      {ticksGolpes.map((golpes) => (
        <g key={golpes}>
          <line x1={sx(golpes)} x2={sx(golpes)} y1={margem.top} y2={height - margem.bottom} stroke="#263238" strokeWidth="0.6" />
          <text x={sx(golpes)} y={height - 28} textAnchor="middle" fontSize="10">{golpes}</text>
        </g>
      ))}
      {reta && (
        <>
          <line x1={reta.x1} y1={reta.y1} x2={reta.x2} y2={reta.y2} stroke="blue" strokeWidth="2" clipPath="url(#clip-limite-liquidez-relatorio)" />
          <line x1={reta.x25} y1={height - margem.bottom} x2={reta.x25} y2={reta.y25} stroke="red" strokeWidth="1.8" clipPath="url(#clip-limite-liquidez-relatorio)" />
          <line x1={margem.left} y1={reta.y25} x2={reta.x25} y2={reta.y25} stroke="red" strokeWidth="1.8" clipPath="url(#clip-limite-liquidez-relatorio)" />
        </>
      )}
      {pontos.map((ponto, index) => (
        <circle key={index} cx={sx(ponto.golpes)} cy={sy(ponto.umidade)} r="3.5" fill="blue" clipPath="url(#clip-limite-liquidez-relatorio)" />
      ))}
      <text x={width / 2} y={height - 8} textAnchor="middle" fontSize="11" fontWeight="700">NÚMERO DE GOLPES</text>
      <text x="33" y={height / 2} textAnchor="middle" fontSize="11" fontWeight="700" transform={`rotate(-90 33 ${height / 2})`}>
        % UMIDADE
      </text>
    </svg>
  );
}

function GranulometriaChart({ peneiramento = [], width = 900, height = 360 }) {
  const peneirasGrafico = ['2"', '1"', '3/8"', "4", "10", "40", "200"];
  const linhas = peneiras
    .map(([nome, abertura], index) => ({
      nome,
      abertura,
      ...(peneiramento[index] || {}),
    }))
    .filter((item) => peneirasGrafico.includes(String(item.nome || "").replace(/^N[º°]\s*/i, "")))
    .filter((item) => n(item.abertura) !== null)
    .sort((a, b) => n(a.abertura) - n(b.abertura));

  const margem = { left: 55, right: 20, top: 35, bottom: 48 };
  const plotW = width - margem.left - margem.right;
  const plotH = height - margem.top - margem.bottom;
  const logs = linhas.map((item) => Math.log10(n(item.abertura)));
  const minLog = Math.min(...logs);
  const maxLog = Math.max(...logs);
  const sx = (abertura) => margem.left + ((Math.log10(n(abertura)) - minLog) / (maxLog - minLog || 1)) * plotW;
  const sy = (valor) => margem.top + ((100 - Number(valor || 0)) / 100) * plotH;
  const path = (campo) =>
    linhas
      .map((item) => ({ x: sx(item.abertura), y: sy(n(item[campo])), v: n(item[campo]) }))
      .filter((p) => p.v !== null)
      .map((p, index) => `${index === 0 ? "M" : "L"} ${p.x} ${p.y}`)
      .join(" ");
  const pontos = (campo) =>
    linhas
      .map((item) => ({ x: sx(item.abertura), y: sy(n(item[campo])), v: n(item[campo]) }))
      .filter((p) => p.v !== null);

  const temFaixa = linhas.some((item) => n(item.faixaDnitMin) !== null || n(item.faixaDnitMax) !== null);

  return (
    <svg className="rc-chart rc-granulometria-chart" viewBox={`0 0 ${width} ${height}`}>
      <text x={width / 2} y="18" textAnchor="middle" fontSize="12" fontWeight="700" fill="blue">PENEIRAS</text>
      <rect x={margem.left} y={margem.top} width={plotW} height={plotH} fill="#fff" stroke="#000" />
      {Array.from({ length: 11 }, (_, i) => {
        const y = margem.top + (i / 10) * plotH;
        const valor = 100 - i * 10;
        return <React.Fragment key={i}><line x1={margem.left} y1={y} x2={width - margem.right} y2={y} stroke="#000" strokeWidth="0.6" /><text x={margem.left - 10} y={y + 3} textAnchor="end" fontSize="10">{valor}</text></React.Fragment>;
      })}
      {linhas.map((item) => {
        const x = sx(item.abertura);
        return <React.Fragment key={item.nome}><line x1={x} y1={margem.top} x2={x} y2={height - margem.bottom} stroke="#000" strokeWidth="0.6" /><text x={x} y="30" textAnchor="middle" fontSize="8">{item.nome}</text><text x={x} y={height - 28} textAnchor="middle" fontSize="9">{item.abertura}</text></React.Fragment>;
      })}
      {temFaixa && <path d={path("faixaDnitMin")} fill="none" stroke="#000" strokeWidth="1" />}
      {temFaixa && <path d={path("faixaDnitMax")} fill="none" stroke="#000" strokeWidth="1" />}
      <path d={path("percentualPassante")} fill="none" stroke="red" strokeWidth="2" strokeDasharray="7 5" />
      {temFaixa &&
        pontos("faixaDnitMin").map((ponto, index) => (
          <circle key={`faixa-min-${index}`} cx={ponto.x} cy={ponto.y} r="3" fill="#000" />
        ))}
      {temFaixa &&
        pontos("faixaDnitMax").map((ponto, index) => (
          <circle key={`faixa-max-${index}`} cx={ponto.x} cy={ponto.y} r="3" fill="#000" />
        ))}
      {pontos("percentualPassante").map((ponto, index) => (
        <circle key={`passante-${index}`} cx={ponto.x} cy={ponto.y} r="3.5" fill="red" stroke="#fff" strokeWidth="1" />
      ))}
      <text x="18" y={height / 2} textAnchor="middle" fontSize="11" fill="blue" transform={`rotate(-90 18 ${height / 2})`}>% QUE PASSA</text>
      <text x={width / 2} y={height - 8} textAnchor="middle" fontSize="11" fill="blue">ABERTURA(mm)</text>
    </svg>
  );
}

function ticksIntervalo(inicio, fim, passo) {
  const ticks = [];
  const primeiro = Math.ceil(inicio / passo) * passo;
  for (let valor = primeiro; valor <= fim + 0.000001; valor += passo) {
    ticks.push(Number(valor.toFixed(6)));
  }
  return ticks;
}

function gerarSpline(pontos = [], amostras = 18) {
  const dados = pontos.filter((p) => p.x !== null && p.y !== null).sort((a, b) => a.x - b.x);
  if (dados.length < 3) return dados;
  const curva = [];
  for (let i = 0; i < dados.length - 1; i += 1) {
    const atual = dados[i];
    const proximo = dados[i + 1];
    const anterior = dados[i - 1] || atual;
    const seguinte = dados[i + 2] || proximo;
    for (let passo = 0; passo < amostras; passo += 1) {
      const t = passo / amostras;
      const tt = t * t;
      const ttt = tt * t;
      const x = atual.x + (proximo.x - atual.x) * t;
      const y =
        0.5 *
        ((2 * atual.y) +
          (-anterior.y + proximo.y) * t +
          (2 * anterior.y - 5 * atual.y + 4 * proximo.y - seguinte.y) * tt +
          (-anterior.y + 3 * atual.y - 3 * proximo.y + seguinte.y) * ttt);
      curva.push({ x, y });
    }
  }
  curva.push(dados[dados.length - 1]);
  return curva;
}

function gerarSplineNatural(pontos = [], amostrasPorTrecho = 16) {
  const dados = pontos
    .filter((p) => p.x !== null && p.y !== null)
    .sort((a, b) => a.x - b.x)
    .filter((p, index, lista) => index === 0 || p.x !== lista[index - 1].x);
  const total = dados.length;
  if (total < 3) return dados;

  const segunda = Array(total).fill(0);
  const u = Array(total - 1).fill(0);

  for (let i = 1; i < total - 1; i += 1) {
    const sig = (dados[i].x - dados[i - 1].x) / (dados[i + 1].x - dados[i - 1].x);
    const p = sig * segunda[i - 1] + 2;
    segunda[i] = (sig - 1) / p;
    u[i] =
      (6 *
        ((dados[i + 1].y - dados[i].y) / (dados[i + 1].x - dados[i].x) -
          (dados[i].y - dados[i - 1].y) / (dados[i].x - dados[i - 1].x))) /
        (dados[i + 1].x - dados[i - 1].x) -
      sig * u[i - 1];
    u[i] /= p;
  }

  for (let k = total - 2; k >= 0; k -= 1) {
    segunda[k] = segunda[k] * segunda[k + 1] + u[k];
  }

  const curva = [];
  for (let i = 0; i < total - 1; i += 1) {
    const h = dados[i + 1].x - dados[i].x;
    if (h === 0) continue;
    for (let passo = 0; passo < amostrasPorTrecho; passo += 1) {
      const x = dados[i].x + (h * passo) / amostrasPorTrecho;
      const a = (dados[i + 1].x - x) / h;
      const b = (x - dados[i].x) / h;
      const y =
        a * dados[i].y +
        b * dados[i + 1].y +
        ((a ** 3 - a) * segunda[i] + (b ** 3 - b) * segunda[i + 1]) * (h ** 2) / 6;
      curva.push({ x, y });
    }
  }
  curva.push(dados[total - 1]);
  return curva;
}

function criarEscalaBanda(valores = [], inicio = 0, fim = 100, passo = 1) {
  const validos = valores.filter((valor) => valor !== null && Number.isFinite(valor));
  const maximoReal = validos.length ? Math.max(...validos) : 1;
  const minimoReal = 0;

  let maximo = Math.ceil(maximoReal / passo) * passo;
  if (maximo <= maximoReal) maximo += passo;
  if (maximo <= 0) maximo = passo;

  const amplitude = maximo - minimoReal || 1;

  const toPlot = (valor) =>
    valor === null || valor === undefined
      ? null
      : inicio + ((valor - minimoReal) / amplitude) * (fim - inicio);

  const fromPlot = (valor) =>
    minimoReal + ((valor - inicio) / (fim - inicio)) * amplitude;

  return {
    domain: [0, 100],
    ticks: ticksIntervalo(minimoReal, maximo, passo).map(toPlot),
    toPlot,
    fromPlot,
  };
}

function calcularTicksDensidade(valores = []) {
  const validos = valores.filter((valor) => valor !== null && Number.isFinite(valor));

  if (!validos.length) {
    return {
      domain: [1.4, 1.8],
      ticks: ticksIntervalo(1.4, 1.8, 0.05),
    };
  }

  const minimo = Math.floor((Math.min(...validos) - 0.05) / 0.05) * 0.05;
  const maximo = Math.ceil((Math.max(...validos) + 0.05) / 0.05) * 0.05;

  return {
    domain: [Number(minimo.toFixed(3)), Number(maximo.toFixed(3))],
    ticks: ticksIntervalo(minimo, maximo, 0.05),
  };
}

function selecionarCampoIsc(cbr = []) {
  const valores254 = cbr.map((linha) => n(linha.isc254)).filter((valor) => valor !== null);
  const valores508 = cbr.map((linha) => n(linha.isc508)).filter((valor) => valor !== null);
  const maior254 = valores254.length ? Math.max(...valores254) : null;
  const maior508 = valores508.length ? Math.max(...valores508) : null;
  return maior508 !== null && (maior254 === null || maior508 > maior254) ? "isc508" : "isc254";
}

function interpolar(pontos = [], x) {
  const dados = pontos.filter((p) => p.x !== null && p.y !== null).sort((a, b) => a.x - b.x);
  if (!dados.length || x === null) return null;
  for (let i = 0; i < dados.length - 1; i += 1) {
    const a = dados[i];
    const b = dados[i + 1];
    if (x >= a.x && x <= b.x) {
      const prop = (x - a.x) / (b.x - a.x || 1);
      return a.y + (b.y - a.y) * prop;
    }
  }
  return null;
}

function CompactacaoChart({ ensaio }) {
  const compactacao = compactos(ensaio);

  const densidade = compactacao
    .map((p) => ({
      umidade: n(p.umidadeCalculada || p.umidade),
      densidadeSeca: n(p.densidadeSeca),
    }))
    .filter((p) => p.umidade !== null && p.densidadeSeca !== null)
    .sort((a, b) => a.umidade - b.umidade);

  const campoIsc = selecionarCampoIsc(ensaio.cbr || []);

  const cbr = (ensaio.cbr || [])
    .slice(0, 5)
    .map((linha, i) => ({
      umidade: n(compactacao[i]?.umidadeCalculada || compactacao[i]?.umidade),
      isc: n(linha[campoIsc] || linha.isc),
    }))
    .filter((p) => p.umidade !== null && p.isc !== null);

  const expansao = (ensaio.expansao || [])
    .slice(0, 5)
    .map((linha, i) => ({
      umidade: n(compactacao[i]?.umidadeCalculada || compactacao[i]?.umidade),
      expansao: n(linha.expansao),
    }))
    .filter((p) => p.umidade !== null && p.expansao !== null);

  const umidadeOtima = n(ensaio.resultados?.umidadeOtima);
  const densidadeMaxima = n(ensaio.resultados?.densidadeMaxima);

  const valoresUmidade = [
    ...densidade.map((p) => p.umidade),
    ...cbr.map((p) => p.umidade),
    ...expansao.map((p) => p.umidade),
  ];

  if (umidadeOtima !== null) valoresUmidade.push(umidadeOtima);

  if (!valoresUmidade.length) {
    return <div className="rc-chart-empty">Sem dados para gráfico</div>;
  }

  const dominioUmidade = [
    Math.floor(Math.min(...valoresUmidade) - 1),
    Math.ceil(Math.max(...valoresUmidade) + 1),
  ];

  const valoresDensidade = densidade.map((p) => p.densidadeSeca);
  if (densidadeMaxima !== null) valoresDensidade.push(densidadeMaxima);

  const escalaDensidade = calcularTicksDensidade(valoresDensidade);
  const [minDensidade, maxDensidade] = escalaDensidade.domain;
  const ticksDensidade = escalaDensidade.ticks;
  const ticksDensidadeSecundarios = ticksIntervalo(minDensidade, maxDensidade, 0.05);
  const ticksUmidade = ticksIntervalo(dominioUmidade[0], dominioUmidade[1], 2);
  const ticksUmidadeSecundarios = ticksIntervalo(dominioUmidade[0], dominioUmidade[1], 1);

  const escalaIsc = criarEscalaBanda(cbr.map((p) => p.isc), 64, 98, 2);
  const escalaExp = criarEscalaBanda(expansao.map((p) => p.expansao), 2, 36, 0.2);

  const curvaDensidade = gerarSplineNatural(
    densidade.map((p) => ({ x: p.umidade, y: p.densidadeSeca }))
  ).map((p) => ({
    umidade: p.x,
    densidadeSuavizada: p.y,
  }));

  const mapa = new Map();

  curvaDensidade.forEach((p) => {
    mapa.set(p.umidade, { ...p });
  });

  densidade.forEach((p) => {
    mapa.set(p.umidade, {
      ...(mapa.get(p.umidade) || {}),
      umidade: p.umidade,
      densidadeSeca: p.densidadeSeca,
    });
  });

  cbr.forEach((p) => {
    mapa.set(p.umidade, {
      ...(mapa.get(p.umidade) || {}),
      umidade: p.umidade,
      isc: p.isc,
      iscPlot: escalaIsc.toPlot(p.isc),
    });
  });

  expansao.forEach((p) => {
    mapa.set(p.umidade, {
      ...(mapa.get(p.umidade) || {}),
      umidade: p.umidade,
      expansao: p.expansao,
      expansaoPlot: escalaExp.toPlot(p.expansao),
    });
  });

  const dados = Array.from(mapa.values()).sort((a, b) => a.umidade - b.umidade);
const sx = (x) =>
  90 + ((x - dominioUmidade[0]) / (dominioUmidade[1] - dominioUmidade[0])) * 760;

const syD = (y) =>
  40 + ((maxDensidade - y) / (maxDensidade - minDensidade)) * 270;

const syPlot = (y) => 40 + ((100 - y) / 100) * 270;

const syIsc = (y) => syPlot(escalaIsc.toPlot(y));
const syExp = (y) => syPlot(escalaExp.toPlot(y));

const pathLinha = (lista, sy) => {
  const curva = gerarSplineNatural(
    lista.map((p) => ({ x: p.umidade, y: p.valor })),
    24
  );

  return curva
    .map((p, i) => `${i === 0 ? "M" : "L"} ${sx(p.x)} ${sy(p.y)}`)
    .join(" ");
};

const linhaIsc = cbr.map((p) => ({
  umidade: p.umidade,
  valor: p.isc,
}));

const linhaExp = expansao.map((p) => ({
  umidade: p.umidade,
  valor: p.expansao,
}));


  return (
  <div className="rc-compactacao-chart-box">
  <svg className="rc-chart rc-compactacao-chart" viewBox="0 0 980 430">
    <text
      x="490"
      y="18"
      textAnchor="middle"
      fontSize="12"
      fontWeight="700"
    >
      CURVA DE COMPACTAÇÃO E CBR
    </text>

    <rect
      x="90"
      y="40"
      width="760"
      height="270"
      fill="#fff"
      stroke="#000"
      strokeWidth="1"
    />

    {ticksUmidade.map((tick) => {
      const x =
        90 +
        ((tick - dominioUmidade[0]) /
          (dominioUmidade[1] - dominioUmidade[0])) *
          760;

      return (
        <g key={tick}>
          <line
            x1={x}
            y1="40"
            x2={x}
            y2="310"
            stroke="#cbd5e1"
            strokeDasharray="3 3"
          />

          <text
            x={x}
            y="326"
            textAnchor="middle"
            fontSize="10"
          >
            {tick.toFixed(1).replace(".", ",")}%
          </text>
        </g>
      );
    })}

    {ticksDensidade.map((tick) => {
      const y =
        40 +
        ((maxDensidade - tick) /
          (maxDensidade - minDensidade)) *
          270;

      return (
        <g key={tick}>
          <line
            x1="90"
            y1={y}
            x2="850"
            y2={y}
            stroke="#cbd5e1"
            strokeDasharray="3 3"
          />

          <text
            x="82"
            y={y + 3}
            textAnchor="end"
            fontSize="10"
          >
            {tick.toFixed(3).replace(".", ",")}
          </text>
        </g>
      );
    })}
 {densidadeMaxima !== null && umidadeOtima !== null && (
      <>
        <line
          x1="90"
          y1={syD(densidadeMaxima)}
          x2={sx(umidadeOtima)}
          y2={syD(densidadeMaxima)}
          stroke="#d32f2f"
          strokeDasharray="6 4"
        />
        <line
  x1={sx(umidadeOtima)}
  y1="40"
  x2={sx(umidadeOtima)}
  y2="310"
  stroke="#d32f2f"
  strokeDasharray="6 4"
/>
      </>
    )}
    <path
      d={curvaDensidade
        .map((p, i) => {
          const x =
            90 +
            ((p.umidade - dominioUmidade[0]) /
              (dominioUmidade[1] - dominioUmidade[0])) *
              760;

          const y =
            40 +
            ((maxDensidade - p.densidadeSuavizada) /
              (maxDensidade - minDensidade)) *
              270;

          return `${i === 0 ? "M" : "L"} ${x} ${y}`;
        })
        .join(" ")}
      fill="none"
      stroke="#0f72cf"
      strokeWidth="2"
    />

    {linhaExp.length > 1 && (
      <path
        d={pathLinha(linhaExp, syExp)}
        fill="none"
        stroke="#ef6c00"
        strokeWidth="2"
      />
    )}

    {linhaIsc.length > 1 && (
      <path
        d={pathLinha(linhaIsc, syIsc)}
        fill="none"
        stroke="#7b1fa2"
        strokeWidth="2"
      />
    )}

    {densidade.map((p, i) => (
      <circle
        key={`dens-${i}`}
        cx={sx(p.umidade)}
        cy={syD(p.densidadeSeca)}
        r="4"
        fill="#fff"
        stroke="#0f72cf"
        strokeWidth="2"
      />
    ))}

    {linhaExp.map((p, i) => (
      <circle
        key={`exp-${i}`}
        cx={sx(p.umidade)}
        cy={syExp(p.valor)}
        r="4"
        fill="#fff"
        stroke="#ef6c00"
        strokeWidth="2"
      />
    ))}

    {linhaIsc.map((p, i) => (
      <circle
        key={`isc-${i}`}
        cx={sx(p.umidade)}
        cy={syIsc(p.valor)}
        r="4"
        fill="#fff"
        stroke="#7b1fa2"
        strokeWidth="2"
      />
    ))}

   

    <text x="36" y="185" fontSize="11" fill="#475569" transform="rotate(-90 36 185)">
      Densidade Seca (g/cm³)
    </text>

    <text x="470" y="348" textAnchor="middle" fontSize="11" fill="#475569">
      Umidade (%)
    </text>

    <text x="885" y="185" fontSize="11" fill="#ef6c00" transform="rotate(-90 885 185)">
      Exp. (%)
    </text>

    <text x="930" y="185" fontSize="11" fill="#7b1fa2" transform="rotate(-90 930 185)">
      I.S.C. (%)
    </text>

    <g fontSize="11">
      <line x1="330" y1="370" x2="350" y2="370" stroke="#0f72cf" />
      <text x="355" y="374" fill="#0f72cf">Densidade seca</text>

      <line x1="455" y1="370" x2="475" y2="370" stroke="#ef6c00" />
      <text x="480" y="374" fill="#ef6c00">Expansão</text>

      <line x1="555" y1="370" x2="575" y2="370" stroke="#7b1fa2" />
      <text x="580" y="374" fill="#7b1fa2">I.S.C.</text>
    </g>
  </svg>
  </div>
);
}

function CompactacaoPage({ ensaio }) {
  const pontos = compactos(ensaio);
  const higro = umidadesHigroscopicas(ensaio);
  const linhas = [
    ["UMIDADE CALCULADA", "umidadeCalculada"], ["ÁGUA ADICIONADA (g)", "aguaAdicionada"],
    ["% ÁGUA ADICIONADA", "percentualAguaAdicionada"], ["Nº DO CILINDRO", "cilindro"],
    ["MASSA DO CILINDRO", "pesoCilindro"], ["MASSA + SOLO + ÁGUA", "pesoSoloUmidoMolde"],
    ["SOLO + ÁGUA", "soloAgua"], ["VOLUME DO CILINDRO", "volumeCilindro"],
    ["DENSIDADE ÚMIDA", "densidadeUmida"], ["DENSIDADE CONVERTIDA", "densidadeConvertida"],
    ["DENSIDADE SECA", "densidadeSeca"],
  ];
  return (
    <Page>
      <Header ensaio={ensaio} codigo="RQ 2.1.1-A" titulo="ENSAIO DE CARACTERIZAÇÃO - ENSAIO DE COMPACTAÇÃO - NBR 7182" />
      <table className="rc-table rc-center rc-compactacao">
        <tbody>
          <tr><th colSpan="6">UMIDADE DE CADA PONTO</th><th colSpan="2">UMIDADE HIGROSCÓPICA</th></tr>
          {["capsula", "capsulaSoloAgua", "capsulaSolo", "agua", "pesoCapsula", "solo", "umidade"].map((campo, idx) => (
            <tr key={campo}>
              <td>{["CÁPSULA Nº", "CÁPSULA + SOLO + ÁGUA", "CÁPSULA + SOLO", "ÁGUA", "CÁPSULA", "SOLO", "% UMIDADE"][idx]}</td>
              {pontos.map((p, i) => <td key={i}>{val(p[campo])}</td>)}
              {higro.map((h, i) => <td key={i}>{val(h[campo])}</td>)}
            </tr>
          ))}
          <tr><td>UMIDADE MÉDIA</td><td colSpan="7">{val(ensaio.umidadeMedia)}</td></tr>
          {linhas.map(([titulo, campo]) => (
            <tr key={campo}>
              <td>{titulo}</td>
              {pontos.map((p, i) => <td key={i}>{val(p[campo] || (campo === "cilindro" ? p.cilindroNumero : ""))}</td>)}
              <td colSpan="2"></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="rc-section-title">CURVA DE COMPACTAÇÃO E CBR</div>
      <CompactacaoChart ensaio={ensaio} />
      <Summary ensaio={ensaio} />
      <div className="rc-observacao">OBSERVAÇÃO:<br />{ensaio.observacao || ""}</div>
      <Footer ensaio={ensaio} />
    </Page>
  );
}

function CompactacaoPageModelo({ ensaio }) {
  const pontos = compactos(ensaio);
  const higro = umidadesHigroscopicas(ensaio);
  const umidadeLinhas = [
    ["CÁPSULA Nº", "capsula"],
    ["CÁPSULA + SOLO + ÁGUA", "capsulaSoloAgua"],
    ["CÁPSULA + SOLO", "capsulaSolo"],
    ["ÁGUA", "agua"],
    ["CÁPSULA", "pesoCapsula"],
    ["SOLO", "solo"],
    ["% UMIDADE", "umidade"],
  ];
  const linhas = [
    ["UMIDADE CALCULADA", "umidadeCalculada", "PESO MATERIAL UMIDO g", ""],
    ["ÁGUA ADICIONADA (g)", "aguaAdicionada", "", ensaio.pesoMaterialUmido],
    ["% ÁGUA ADICIONADA", "percentualAguaAdicionada", "PESO MATERIAL SECO g", ""],
    ["Nº DO CILINDRO", "cilindro", "", ensaio.pesoMaterialSeco],
    ["MASSA DO CILINDRO", "pesoCilindro", "% MATERIAL RET. PEN. Nº 4", ""],
    ["MASSA + SOLO + ÁGUA", "pesoSoloUmidoMolde", "", ensaio.percentualRetidoPeneira4],
    ["SOLO + ÁGUA", "soloAgua", "ESPESSURA DO DISCO mm", ""],
    ["VOLUME DO CILINDRO", "volumeCilindro", "", ensaio.espessuraDisco],
    ["DENSIDADE ÚMIDA", "densidadeUmida", "CAMADAS", ""],
    ["DENSIDADE CONVERTIDA", "densidadeConvertida", "", ensaio.camadas],
    ["DENSIDADE SECA", "densidadeSeca", "Nº DE GOLPES:", ensaio.numeroGolpes],
  ];

  return (
    <Page>
      <Header
        ensaio={ensaio}
        codigo="RQ 2.1.1-A"
        titulo="ENSAIO DE CARACTERIZAÇÃO - ENSAIO DE COMPACTAÇÃO - NBR 7182"
      />
      <table className="rc-table rc-center rc-compactacao-modelo">
        <colgroup>
          <col className="rc-col-label" />
          <col span="5" className="rc-col-point" />
          <col className="rc-col-side-label" />
          <col className="rc-col-side-value" />
        </colgroup>
        <tbody>
          <tr>
            <th colSpan="6">UMIDADE DE CADA PONTO</th>
            <th colSpan="2">UMIDADE HIGROSCÓPICA</th>
          </tr>
          {umidadeLinhas.map(([titulo, campo]) => (
            <tr key={campo}>
              <td>{titulo}</td>
              {pontos.map((p, i) => (
                <td key={i}>{val(p[campo])}</td>
              ))}
              {higro.map((h, i) => (
                <td key={i}>{val(h[campo])}</td>
              ))}
            </tr>
          ))}
          <tr>
            <td>UMIDADE MÉDIA</td>
            <td colSpan="5"></td>
            <td colSpan="2">{val(ensaio.umidadeMedia)}</td>
          </tr>
          {linhas.map(([titulo, campo, ladoTitulo, ladoValor], index) => {
            const proximaLinhaValor = ladoTitulo && !ladoValor && linhas[index + 1]?.[3];
            const linhaValorAnterior = !ladoTitulo && ladoValor && linhas[index - 1]?.[2];
            return (
            <tr key={campo}>
              <td>{titulo}</td>
              {pontos.map((p, i) => (
                <td key={i}>{val(p[campo] || (campo === "cilindro" ? p.cilindroNumero : ""))}</td>
              ))}
              {ladoTitulo && ladoValor ? (
                <>
                  <td className="rc-side-label rc-side-final">{ladoTitulo}</td>
                  <td className="rc-side-value rc-side-final">{val(ladoValor)}</td>
                </>
              ) : (
                <td
                  colSpan="2"
                  className={[
                    ladoTitulo ? "rc-side-label" : "rc-side-value",
                    proximaLinhaValor ? "rc-side-title-open" : "",
                    linhaValorAnterior ? "rc-side-value-open" : "",
                  ].filter(Boolean).join(" ")}
                >
                  {ladoTitulo || val(ladoValor)}
                </td>
              )}
            </tr>
          )})}
        </tbody>
      </table>
      
      <CompactacaoChart ensaio={ensaio} />
      <Summary ensaio={ensaio} />
      <div className="rc-observacao">OBSERVAÇÃO:<br />{ensaio.observacao || ""}</div>
      <Footer ensaio={ensaio} />
    </Page>
  );
}

function CbrPage({ ensaio }) {
  const expansao = (ensaio.expansao || []).slice(0, 5);
  const cbr = (ensaio.cbr || []).slice(0, 5);
  return (
    <Page className="rc-page-cbr">
      <Header ensaio={ensaio} codigo="RQ 2.1.1-B" titulo="ENSAIO DE CARACTERIZAÇÃO - ÍNDICE DE SUPORTE CALIFÓRNIA E EXPANSÃO - NBR 9895" />
      <div className="rc-section-gap" />
      <div className="rc-section-title rc-section-title-top">ENSAIO DE EXPANSÃO</div>
      <table className="rc-table rc-center rc-expansao">
        <colgroup>
          {expansao.map((_, i) => (
            <React.Fragment key={i}>
              <col className="rc-exp-col-label" />
              <col className="rc-exp-col-value" />
              <col className="rc-exp-col-value" />
            </React.Fragment>
          ))}
        </colgroup>
        <tbody>
          <tr>{expansao.map((e, i) => <React.Fragment key={i}><td className="rc-exp-label">CILINDRO</td><td colSpan="2">{val(e.cilindro)}</td></React.Fragment>)}</tr>
          <tr>{expansao.map((_, i) => <React.Fragment key={i}><td className="rc-exp-label">DATA</td><td className="rc-exp-label">HORA</td><td className="rc-exp-label">LEITURA</td></React.Fragment>)}</tr>
          <tr>{expansao.map((e, i) => <React.Fragment key={i}><td>{leituraRegistrada(e.leituraInicial) ? dataBR(e.dataInicial) : "-"}</td><td>{leituraRegistrada(e.leituraInicial) ? val(e.horaInicial) : "-"}</td><td>{val(e.leituraInicial)}</td></React.Fragment>)}</tr>
          {[0, 1, 2].map((leituraIndex) => (
            <tr key={leituraIndex}>{expansao.map((e, i) => {
              const leitura = e.leiturasDiarias?.[leituraIndex] || {};
              return <React.Fragment key={i}><td>{leituraRegistrada(leitura.leitura) ? dataBR(leitura.data) : "-"}</td><td>{leituraRegistrada(leitura.leitura) ? val(leitura.hora) : "-"}</td><td>{val(leitura.leitura)}</td></React.Fragment>;
            })}</tr>
          ))}
          <tr>{expansao.map((e, i) => <React.Fragment key={i}><td>{leituraRegistrada(e.leituraFinal) ? dataBR(e.dataFinal) : "-"}</td><td>{leituraRegistrada(e.leituraFinal) ? val(e.horaFinal) : "-"}</td><td>{val(e.leituraFinal)}</td></React.Fragment>)}</tr>
          <tr>{expansao.map((e, i) => <React.Fragment key={i}><td className="rc-exp-label">DIFERENÇA</td><td colSpan="2">{val(e.diferenca)}</td></React.Fragment>)}</tr>
          <tr>{expansao.map((e, i) => <React.Fragment key={i}><td className="rc-exp-label">EXPANSÃO</td><td>{val(e.expansao)}</td><td>%</td></React.Fragment>)}</tr>
        </tbody>
      </table>
      <div className="rc-section-gap" />
      <table className="rc-table rc-center rc-cbr">
        <colgroup>
          <col className="rc-cbr-col-cilindro" />
          <col className="rc-cbr-col-label" />
          {penetracoesCBR.map((p) => <col key={p.mm} className="rc-cbr-col-valor" />)}
        </colgroup>
        <tbody>
          <tr><td>Const. Anel:</td><td>{val(ensaio.constanteAnelCbr)}</td><td colSpan={11}><b>PENETRAÇÃO</b></td></tr>
          <tr><td rowSpan="4">CILINDRO Nº</td><td>PENETRAÇÃO (mm)</td>{penetracoesCBR.map((p) => <td key={p.mm}>{p.mm}</td>)}</tr>
          <tr><td>TEMPO (min)</td>{penetracoesCBR.map((p) => <td key={p.mm}>{p.tempo}</td>)}</tr>
          <tr><td>LEITURA</td>{penetracoesCBR.map((p) => <td key={p.mm}>-</td>)}</tr>
          <tr><td>PRESSÃO (kg/cm²)</td>{penetracoesCBR.map((p) => <td key={p.mm}>-</td>)}</tr>
          {cbr.map((linha, idx) => (
            <React.Fragment key={idx}>
              {["leitura", "pressao", "correcao", "isc"].map((campo, ri) => (
                <tr key={campo}>
                  {ri === 0 && <td rowSpan="4">{val(linha.cilindro)}</td>}
                  <td>
                    {campo === "isc"
                      ? "I.S.C."
                      : campo === "pressao"
                      ? "PRESSÃO (kg/cm²)"
                      : campo === "correcao" && linha.aplicarCorrecao
                      ? `CORREÇÃO c=${val(linha.correcaoCbrMm)} mm`
                      : campo.toUpperCase()}
                  </td>
                  {penetracoesCBR.map((p, i) => {
                    const leitura = linha.leituras?.[i] || {};
                    const valor = campo === "isc" ? (p.mm === "2,54" ? linha.isc254 : p.mm === "5,08" ? linha.isc508 : "") : leitura[campo];
                    return <td key={p.mm}>{val(valor)}</td>;
                  })}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className="rc-section-title rc-section-title-open">PENETRAÇÃO mm</div>
      <div className="rc-mini-charts">
        {cbr.map((linha, i) => {
          const deslocamentoCorrecao = n(linha.correcaoCbrMm);
          const correcaoAtiva =
            linha.aplicarCorrecao === true &&
            deslocamentoCorrecao !== null &&
            deslocamentoCorrecao > 0;
          const leitura254 = (linha.leituras || []).find(leitura => n(leitura.mm) === 2.54);
          const leitura508 = (linha.leituras || []).find(leitura => n(leitura.mm) === 5.08);
          const guias = correcaoAtiva
            ? [
                { label: "P1", x: 2.54, y: n(leitura254?.pressao), color: "#555" },
                { label: "P1'", x: 2.54 + deslocamentoCorrecao, y: n(leitura254?.correcao), color: "#c62828" },
                { label: "P2", x: 5.08, y: n(leitura508?.pressao), color: "#555" },
                { label: "P2'", x: 5.08 + deslocamentoCorrecao, y: n(leitura508?.correcao), color: "#c62828" },
              ].filter(guia => guia.y !== null)
            : [];
          const serieOriginal = {
            name: "Pressão",
            points: [
              { x: 0, y: 0 },
              ...(linha.leituras || []).map((leitura) => ({
                x: n(leitura.mm),
                y: n(leitura.pressao),
              })),
            ],
          };
          const pontoInflexao = correcaoAtiva
            ? {
                x: n(linha.correcaoCbrInflexaoMm),
                y: n(linha.correcaoCbrInflexaoPressao),
              }
            : null;
          const tangente =
            pontoInflexao &&
            pontoInflexao.x !== null &&
            pontoInflexao.y !== null
              ? {
                  x1: deslocamentoCorrecao,
                  y1: 0,
                  x2: pontoInflexao.x,
                  y2: pontoInflexao.y,
                }
              : null;
          return (
            <PolyChart
              key={i}
              width={145}
              height={230}
              yLabel="PRESSÃO"
              xLabel=""
              colors={["#000"]}
              series={[serieOriginal]}
              guides={guias}
              correctionOffset={correcaoAtiva ? deslocamentoCorrecao : null}
              tangent={tangente}
            />
          );
        })}
      </div>
      <Summary ensaio={ensaio} />
      <Footer ensaio={ensaio} />
    </Page>
  );
}

function GranulometriaPage({ ensaio }) {
  const higro = umidadesHigroscopicas(ensaio);
  const granulometria = ensaio.granulometria || {};
  const peneiramento = granulometria.peneiramento || [];
  const amostra = granulometria.amostraSeca || {};
  const faixaSelecionada = granulometria.faixaDnitSelecionada || "";
  const linhasAmostraSeca = [
    { label: "Amostra Total Úmida (g)", valor: amostra.amostraTotalUmida },
    { label: "Solo Seco retido pen. Nº 10", valor: granulometria.soloSecoRetidoPeneira10 ?? amostra.soloSecoRetido10 },
    { label: "Solo Úmido pass. na peneira Nº 10", valor: granulometria.soloUmidoPassante10 ?? amostra.soloUmidoPassante10 },
    { label: "Solo seco pass. na peneira Nº 10", valor: granulometria.soloSecoPassante10 ?? amostra.soloSecoPassante10 },
    { label: "Amostra Total Seca", valor: granulometria.amostraTotalSeca ?? amostra.amostraTotalSeca },
    { label: "Amostra menor nº 10 Úmida", valor: amostra.amostraMenor10Umida },
    { label: "Amostra menor nº 10 Seca", valor: granulometria.amostraMenor10Seca ?? amostra.amostraMenor10Seca },
  ];
  const linhasEsquerda = [
    ...["capsula", "capsulaSoloAgua", "capsulaSolo", "agua", "pesoCapsula", "solo", "umidade"].map((campo, idx) => ({
      tipo: "higro",
      label: ["CÁPSULA Nº", "CÁPSULA + SOLO + ÁGUA", "CÁPSULA + SOLO", "ÁGUA", "CÁPSULA", "SOLO", "% UMIDADE"][idx],
      valores: higro.map((h) => val(h[campo])),
    })),
    { tipo: "valor", label: "UMIDADE MÉDIA", valor: val(ensaio.umidadeMedia) },
    { tipo: "titulo", label: "AMOSTRA TOTAL SECA" },
    ...linhasAmostraSeca.map((linha) => ({ tipo: "valor", label: linha.label, valor: val(linha.valor) })),
    { tipo: "classificacao", label: 'CLASSIFICAÇÃO "IG"=', valor: val(ensaio.granulometria?.classificacaoIg) },
    { tipo: "classificacao", label: 'CLASSIFICAÇÃO "TRB"=', valor: val(ensaio.granulometria?.classificacaoTrb) },
    { tipo: "classificacao", label: 'CLASSIFICAÇÃO "SUCS"=', valor: val(ensaio.granulometria?.classificacaoSucs) },
  ];
  const renderEsquerda = (linha) => {
    if (!linha) return <td colSpan="3"></td>;
    if (linha.tipo === "titulo") return <td colSpan="3"><b>{linha.label}</b></td>;
    if (linha.tipo === "classificacao") return <td colSpan="3">{linha.label} {linha.valor}</td>;
    if (linha.tipo === "valor") return <><td>{linha.label}</td><td colSpan="2">{linha.valor}</td></>;
    return <><td>{linha.label}</td><td>{linha.valores[0]}</td><td>{linha.valores[1]}</td></>;
  };
  return (
    <Page>
      <Header ensaio={ensaio} codigo="RQ 2.1.1-C" titulo="ENSAIO DE CARACTERIZAÇÃO - ANÁLISE GRANULOMÉTRICA DE SOLOS - NBR 7181" />
      <table className="rc-table rc-center rc-granulometria-unificada">
        <colgroup>
          <col className="rc-granulo-label" />
          <col className="rc-granulo-valor" />
          <col className="rc-granulo-valor" />
          <col className="rc-granulo-peneira" />
          <col className="rc-granulo-mm" />
          <col className="rc-granulo-peso" />
          <col className="rc-granulo-percentual" />
          <col className="rc-granulo-percentual" />
          <col className="rc-granulo-passa" />
          <col className="rc-granulo-faixa" />
          <col className="rc-granulo-faixa" />
        </colgroup>
        <thead>
          <tr>
            <th colSpan="3">UMIDADE HIGROSCÓPICA</th>
            <th colSpan="2" rowSpan="3">PENEIRAS</th>
            <th colSpan="6">PENEIRAMENTO</th>
          </tr>
          <tr>
            {renderEsquerda(linhasEsquerda[0])}
            <td colSpan="3">Material Retido</td>
            <td rowSpan="2">% Que Passa<br />da Amostra<br />Total</td>
            <td colSpan="2">"FAIXA DNIT"</td>
          </tr>
          <tr>
            {renderEsquerda(linhasEsquerda[1])}
            <td>Peso (g)</td>
            <td>% Amost. Total</td>
            <td>% Acumulado</td>
            <td colSpan="2">{faixaSelecionada || "-"}</td>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: Math.max(linhasEsquerda.length - 2, peneiras.length) }).map((_, i) => {
            const esquerda = linhasEsquerda[i + 2];
            const [nome, abertura] = peneiras[i] || ["", ""];
            const linha = peneiramento[i] || {};
            return (
              <tr key={i}>
                {renderEsquerda(esquerda)}
                <td>{nome}</td>
                <td>{abertura}</td>
                <td>{val(linha.pesoRetido)}</td>
                <td>{val(linha.percentualRetido)}</td>
                <td>{val(linha.acumulado)}</td>
                <td>{val(linha.percentualPassante)}</td>
                <td>{val(linha.faixaDnitMin || linha.faixaDnit)}</td>
                <td>{val(linha.faixaDnitMax)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="rc-section-title">PENEIRAS</div>
      <GranulometriaChart peneiramento={peneiramento} />
      <div className="rc-observacao">OBSERVAÇÃO:<br />{ensaio.observacao || ""}</div>
      <Footer ensaio={ensaio} />
    </Page>
  );
}

function LimitesPage({ ensaio }) {
  const limites = ensaio.limites || {};
  const liquidez = limites.liquidez || [];
  const plasticidade = limites.plasticidade || [];
  const res = limites.resultados || {};
  const equivalenteAreia = limites.equivalenteAreia || {};
  const massaEspecificaReal = limites.massaEspecificaReal || {};
  const densidadeSolta = limites.densidadeSolta || {};
  const tabelaLimite = (titulo, linhas, comGolpes) => (
    <table className="rc-table rc-center rc-limites-table">
      <colgroup>
        <col className="rc-limites-label" />
        {Array.from({ length: 5 }).map((_, index) => (
          <col key={index} className="rc-limites-value" />
        ))}
      </colgroup>
      <tbody>
        <tr><th colSpan="6">{titulo}</th></tr>
        {[
          ["Cápsula Nº", "capsula"], ["Cáp. + Solo + Água", "capsulaSoloAgua"],
          ["Cápsula + Solo", "capsulaSolo"], ["Água", "agua"], ["Cápsula", "pesoCapsula"],
          ["Solo", "solo"], ["Umidade", "umidade"], ...(comGolpes ? [["Nº DE GOLPES", "golpes"]] : []),
        ].map(([label, campo]) => <tr key={campo}><td>{label}</td>{linhas.slice(0, 5).map((l, i) => <td key={i}>{val(l[campo])}</td>)}</tr>)}
      </tbody>
    </table>
  );
  return (
    <Page>
      <Header ensaio={ensaio} codigo="RQ 2.1.1-D" titulo="ENSAIO DE CARACTERIZAÇÃO - LIMITE DE LIQUIDEZ E PLASTICIDADE NBR 6459 E NBR 7180" revisao="Revisão 00" />
      <div className="rc-limites">
        <div>
          {tabelaLimite("LIMITE DE LIQUIDEZ", liquidez, true)}
          {tabelaLimite("LIMITE DE PLASTICIDADE", plasticidade, false)}
          <LimiteLiquidezChart
            liquidez={liquidez}
            escala={limites.escalaGraficoLiquidez || {}}
            width={475}
            height={378}
          />
        </div>
        <div className="rc-limites-right">
          <table className="rc-table rc-center rc-limites-resultados">
            <colgroup>
              <col className="rc-limites-result-label" />
              <col className="rc-limites-result-sigla" />
              <col className="rc-limites-result-value" />
            </colgroup>
            <tbody>
              <tr><th colSpan="3">ÍNDICE DE PLASTICIDADE</th></tr>
              <tr className="rc-limites-result-row"><td>Limite de Liquidez</td><td>LL</td><td><b>{val(res.limiteLiquidez)}</b></td></tr>
              <tr className="rc-limites-result-row"><td>Limite de Plasticidade</td><td>LP</td><td><b>{val(res.limitePlasticidade)}</b></td></tr>
              <tr className="rc-limites-result-row"><td>Índice de Plasticidade</td><td>IP</td><td><b>{val(res.indicePlasticidade)}</b></td></tr>
            </tbody>
          </table>

          <table className="rc-table rc-center rc-side-box rc-limites-side-box rc-equivalente-areia">
            <colgroup>
              <col className="rc-limites-side-label" />
              <col className="rc-limites-side-unit" />
              <col className="rc-limites-side-unit" />
              <col className="rc-limites-side-value" />
            </colgroup>
            <tbody>
              <tr><th colSpan="4">EQUIVALENTE DE AREIA</th></tr>
              <tr><td>Topo da Areia</td><td></td><td></td><td>{val(equivalenteAreia.topoAreia)}</td></tr>
              <tr><td>Topo da Argila</td><td></td><td></td><td>{val(equivalenteAreia.topoArgila)}</td></tr>
              <tr><td>E.A.</td><td></td><td></td><td>{val(equivalenteAreia.ea)}</td></tr>
              <tr className="rc-limites-media-row"><td>Média</td><td colSpan="3">{val(equivalenteAreia.media)}</td></tr>
            </tbody>
          </table>

          <table className="rc-table rc-center rc-side-box rc-limites-side-box rc-massa-real">
            <colgroup>
              <col className="rc-limites-side-label" />
              <col className="rc-limites-side-unit" />
              <col className="rc-limites-side-unit" />
              <col className="rc-limites-side-value" />
            </colgroup>
            <tbody>
              <tr><th colSpan="4">MASSA ESPECÍFICA REAL</th></tr>
              <tr><td>Temperatura</td><td>°C</td><td></td><td>{val(massaEspecificaReal.temperatura)}</td></tr>
              <tr><td rowSpan="2">Picnômetro</td><td>Nº</td><td></td><td>{val(massaEspecificaReal.picnometroNumero)}</td></tr>
              <tr><td>g</td><td></td><td>{val(massaEspecificaReal.picnometro)}</td></tr>
              <tr><td>Picnômetro + solo</td><td>g</td><td></td><td>{val(massaEspecificaReal.picnometroSolo)}</td></tr>
              <tr><td>Pic. + solo + água</td><td>g</td><td></td><td>{val(massaEspecificaReal.picSoloAgua)}</td></tr>
              <tr><td>Picnômetro + água</td><td>g</td><td></td><td>{val(massaEspecificaReal.picnometroAgua)}</td></tr>
              <tr><td>Água deslocada</td><td>g</td><td></td><td>{val(massaEspecificaReal.aguaDeslocada)}</td></tr>
              <tr><td>Massa Específica Real</td><td></td><td></td><td>{val(massaEspecificaReal.massaEspecificaReal)}</td></tr>
              <tr className="rc-limites-media-row"><td>Média</td><td>g/m³</td><td colSpan="2">{val(massaEspecificaReal.media)}</td></tr>
            </tbody>
          </table>

          <table className="rc-table rc-center rc-side-box rc-limites-side-box rc-densidade-solta">
            <colgroup>
              <col className="rc-limites-side-label" />
              <col className="rc-limites-side-unit" />
              <col className="rc-limites-side-unit" />
              <col className="rc-limites-side-value" />
            </colgroup>
            <tbody>
              <tr><th colSpan="4">DENSIDADE SOLTA</th></tr>
              <tr><td>Tara do Recipiente</td><td></td><td></td><td>{val(densidadeSolta.taraRecipiente)}</td></tr>
              <tr><td>Vol. do Recipiente</td><td></td><td></td><td>{val(densidadeSolta.volumeRecipiente)}</td></tr>
              <tr><td>Solo + Recipiente</td><td></td><td></td><td>{val(densidadeSolta.soloRecipiente)}</td></tr>
              <tr><td>Solo</td><td></td><td></td><td>{val(densidadeSolta.solo)}</td></tr>
              <tr><td>Densidade Solta</td><td></td><td></td><td>{val(densidadeSolta.densidadeSolta)}</td></tr>
              <tr className="rc-limites-media-row"><td>Média</td><td colSpan="3">{val(densidadeSolta.media)}</td></tr>
              <tr className="rc-limites-empolamento-row"><td>Empolamento<br />da Camada</td><td colSpan="3">{val(densidadeSolta.empolamentoCamada)}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="rc-observacao rc-limites-observacao">OBSERVAÇÃO:<br />{ensaio.observacao || ""}</div>
      <Footer ensaio={ensaio} />
    </Page>
  );
}

export default function RelatorioCompactacaoPrint({ ensaio, onVoltar, autoPrint = false }) {
  useEffect(() => {
    const tituloAnterior = document.title;
    document.title = String(ensaio?.codigo || ensaio?.registroNumero || tituloAnterior);
    return () => { document.title = tituloAnterior; };
  }, [ensaio?.codigo, ensaio?.registroNumero]);

  useEffect(() => {
    if (!autoPrint) return;
    const timer = setTimeout(() => window.print(), 300);
    return () => clearTimeout(timer);
  }, [autoPrint]);

  return (
    <Box className="rc-print-root" sx={{ p: 2, background: "#f5f7fb", minHeight: "100vh" }}>
      <style>{`
        .rc-print-root { page: relatorioCompactacaoPrint; }
        @page relatorioCompactacaoPrint { size: A4 portrait; margin: 0; }
        .rc-page { width: 210mm; min-height: 297mm; margin: 0 auto 10mm; background: white; color: #000; border: 0; font-family: Arial, sans-serif; font-size: 9px; box-sizing: border-box; page-break-after: always; break-after: page; position: relative; overflow: hidden; padding: 4mm 6mm 12mm; }
        .rc-page-inner { width: 100%; box-sizing: border-box; }
        .rc-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
        .rc-table td, .rc-table th { border: 1px solid #000; padding: 1px 2px; vertical-align: middle; font-size: 9px; font-weight: 400; }
        .rc-table th, .rc-section-title { font-weight: 700; text-align: center; }
        .rc-center td, .rc-center th { text-align: center; }
        .rc-logo { width: 38mm; text-align: center; }
        .rc-logo-img { width: 36mm; max-height: 19mm; object-fit: contain; display: block; margin: 0 auto; }
        .rc-brand { color: #26356d; font-size: 22px; font-weight: 700; font-style: italic; }
        .rc-brand-sub { color: #26356d; font-size: 12px; font-style: italic; }
        .rc-iso { color: #26356d; font-size: 8px; margin-top: 6px; }
        .rc-title { text-align: center; font-size: 12px; line-height: 1.15; }
        .rc-code { width: 26mm; text-align: center; font-size: 12px !important; }
        .rc-meta td { text-align: center; }
        .rc-section-title { border: 1px solid #000; border-top: 0; padding: 1mm; font-size: 10px; }
        .rc-section-title-top { border-top: 1px solid #000; }
        .rc-section-title-open { border-bottom: 0; }
        .rc-section-gap { height: 2.2mm; border-left: 1px solid #000; border-right: 1px solid #000; }
        .rc-table + .rc-table tr:first-child > * { border-top: 0; }
        .rc-table + .rc-section-title { border-top: 0; }
        .rc-section-title-open + .rc-table tr:first-child > * { border-top: 0; }
        .rc-grid-2 > .rc-table + .rc-table tr > :first-child { border-left: 0; }
        .rc-grid-2 + .rc-section-title { border-top: 0; }
        .rc-grid-2 > .rc-table tr:first-child > * { border-top: 0; }
        .rc-granulometria-unificada td,
        .rc-granulometria-unificada th { height: 5.2mm; line-height: 1.05; padding: 1px 2px; }
        .rc-granulometria-unificada th { background: #fff; }
        .rc-granulo-label { width: 21%; }
        .rc-granulo-valor { width: 7%; }
        .rc-granulo-peneira { width: 7%; }
        .rc-granulo-mm { width: 7%; }
        .rc-granulo-peso { width: 9%; }
        .rc-granulo-percentual { width: 8.5%; }
        .rc-granulo-passa { width: 10%; }
        .rc-granulo-faixa { width: 7%; }
        .rc-compactacao-modelo td, .rc-compactacao-modelo th { height: 6.8mm; line-height: 1.12; padding: 1px 2px; }
        .rc-compactacao td, .rc-compactacao th { height: 7.8mm; line-height: 1.12; }
        .rc-compactacao-modelo .rc-col-label { width: 18%; }
        .rc-compactacao-modelo .rc-col-point { width: 10.5%; }
        .rc-compactacao-modelo .rc-col-side-label { width: 18%; }
        .rc-compactacao-modelo .rc-col-side-value { width: 11.5%; }
        .rc-compactacao-modelo .rc-side-label { font-size: 8px; white-space: nowrap; }
        .rc-compactacao-modelo .rc-side-value { font-size: 9px; }
        .rc-compactacao-modelo .rc-side-title-open { border-bottom-color: transparent; }
        .rc-compactacao-modelo .rc-side-value-open { border-top-color: transparent; }
        .rc-summary td, .rc-summary th { font-size: 9px; height: 5mm; }
        .rc-compactacao td, .rc-compactacao th { width: 12.5%; }
        .rc-expansao td { line-height: 1.05; height: 5mm; padding-top: 0; padding-bottom: 0; }
        .rc-exp-col-label { width: 13mm; }
        .rc-exp-col-value { width: calc((100% - 65mm) / 10); }
        .rc-expansao .rc-exp-label { font-size: 7px !important; font-weight: 400 !important; white-space: nowrap; letter-spacing: 0; }
        .rc-cbr td { line-height: 1.05; height: 5.3mm; }
        .rc-cbr-col-cilindro { width: 17mm; }
        .rc-cbr-col-label { width: 31mm; }
        .rc-cbr-col-valor { width: calc((100% - 48mm) / 11); }
       .rc-chart-title {
          text-align: center;
          font-size: 10px;
          font-weight: 700;
          margin-top: 4mm;
          margin-bottom: 1mm;
        }

        .rc-compactacao-chart-box {
          width: 100%;
          height: 72mm;
          border-left: 1px solid #000;
          border-right: 1px solid #000;
          border-top: 0;
          box-sizing: border-box;
          padding: 0 6mm;
        }

        .rc-chart {
          width: 100%;
          height: auto;
          display: block;
        }
        .rc-chart-empty { height: 74mm; display: grid; place-items: center; border: 1px solid #000; }
        .rc-section-title + .rc-chart {
          border-left: 1px solid #000;
          border-right: 1px solid #000;
          border-top: 0;
          box-sizing: border-box;
        }
        .rc-observacao { border: 1px solid #000; min-height: 12mm; padding: 1mm; }
        .rc-chart + .rc-observacao,
        .rc-mini-charts + .rc-observacao,
        .rc-compactacao-chart-box + .rc-summary tr:first-child > *,
        .rc-observacao + .rc-summary tr:first-child > *,
        .rc-summary + .rc-footer td { border-top: 0; }
        .rc-summary + .rc-observacao { border-top: 0; }
        .rc-observacao + .rc-footer td { border-top: 0; }
        .rc-footer td { height: 13mm; vertical-align: top; }
        .rc-page-cbr .rc-footer td { height: 9mm; line-height: 1.05; padding-top: 0.5mm; padding-bottom: 0.5mm; }
        .rc-page-cbr .rc-footer br + br { display: none; }
        .rc-sign { color: blue; font-style: italic; font-size: 18px; text-align: center; margin-top: 3mm; }
        .rc-mini-charts { display: grid; grid-template-columns: repeat(5, 1fr); gap: 6px; padding: 8px 16px; border-left: 1px solid #000; border-right: 1px solid #000; border-top: 0; }
        .rc-mini-charts .rc-chart { height: 170px; }
        .rc-page-cbr .rc-mini-charts { padding-top: 2px; padding-bottom: 2px; }
        .rc-page-cbr .rc-mini-charts .rc-chart { height: 90px; }
        .rc-grid-2 { display: grid; grid-template-columns: 39% 61%; }
        .rc-limites { display: grid; grid-template-columns: 66% 34%; gap: 0; padding: 0; align-items: start; }
        .rc-limites-right { display: flex; flex-direction: column; gap: 0; }
        .rc-limites-right > .rc-table { width: 100%; margin: 0; box-sizing: border-box; table-layout: fixed; }
        .rc-limites .rc-table td,
        .rc-limites .rc-table th { height: 6.25mm; line-height: 1.1; padding: 1px 2px; font-size: 9px; }
        .rc-limites .rc-table th { background: #fff; font-weight: 700; }
        .rc-limites-table + .rc-limites-table tr:first-child > * { border-top: 0; }
        .rc-limites-label { width: 28%; }
        .rc-limites-value { width: 14.4%; }
        .rc-limites-result-label { width: 58%; }
        .rc-limites-result-sigla { width: 16%; }
        .rc-limites-result-value { width: 26%; }
        .rc-limites-resultados td,
        .rc-limites-resultados th { height: 6.25mm; }
        .rc-limites-resultados .rc-limites-result-row td { height: 12.2mm; }
        .rc-side-box { margin-bottom: 0; }
        .rc-limites-side-box { border-top: 1px solid #000; }
        .rc-limites-side-box tr:first-child > * { border-top: 1px solid #000 !important; }
        .rc-limites-side-box td,
        .rc-limites-side-box th { height: 6.25mm !important; }
        .rc-limites-side-box th { height: 8.2mm !important; }
        .rc-limites-side-label { width: 52%; }
        .rc-limites-side-unit { width: 16%; }
        .rc-limites-side-value { width: 16%; }
        .rc-limites-side-box td:first-child { text-align: left; }
        .rc-limites-side-box .rc-limites-media-row td,
        .rc-limites-side-box .rc-limites-empolamento-row td { font-weight: 700; text-align: center; }
        .rc-densidade-solta td { height: 8.4mm !important; }
        .rc-limites-side-box .rc-limites-empolamento-row td { height: 10.8mm !important; }
        .rc-limite-liquidez-chart { max-height: none; }
        .rc-limites-observacao { min-height: 12mm; }
        .rc-limites-observacao,
        .rc-limites-observacao + .rc-footer { width: 100%; margin-left: 0; box-sizing: border-box; }
        .no-print { position: fixed; top: 10px; right: 18px; z-index: 20; justify-content: flex-end; background: #f5f7fb; padding: 6px; border-radius: 8px; }
        @media print {
          html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
          .rc-print-root { background: #fff !important; box-sizing: border-box; min-height: auto !important; padding: 0 !important; width: auto !important; }
          .no-print { display: none !important; }
          .rc-page { width: 210mm; min-height: 297mm; margin: 0; border: 0; page-break-after: always; break-after: page; padding: 4mm 6mm 12mm; }
          .rc-page:last-of-type { page-break-after: auto; break-after: auto; }
          .rc-page, .rc-page * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          .rc-table tr, .rc-table td, .rc-table th, .rc-section-title, .rc-compactacao-chart, .rc-summary, .rc-observacao, .rc-footer { break-inside: avoid !important; page-break-inside: avoid !important; }
        }
      `}</style>
      <Stack className="no-print" direction="row" spacing={1}>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onVoltar}>Voltar</Button>
        <Button variant="contained" startIcon={<PrintIcon />} onClick={() => window.print()}>Imprimir</Button>
      </Stack>
      <CompactacaoPageModelo ensaio={ensaio} />
      <CbrPage ensaio={ensaio} />
      <GranulometriaPage ensaio={ensaio} />
      <LimitesPage ensaio={ensaio} />
    </Box>
  );
}

